import { Box, Button, List, ListItem, Typography } from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import { useTranslation } from 'react-i18next'
import { MdExpandMore } from 'react-icons/md'

import bluetick from '@/assets/images/bluetick.svg'
import greenCheck from '@/assets/images/greentick.svg'

import PlanDialog from './PlanDialog'

export default function MobileCompareplans({
  buttonText,
}: {
  buttonText?: string
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'comparePlans' })

  const plans = [
    {
      title: 'Shadeguide AI',
      monthPrice: `€39/${t('month')}`,
      yearPrice: `€365/${t('year')}`,
      subPrice: `€30/${t('month')}`,
      features: [
        { title: 'myProjects', tick: 'true' },
        { title: 'shadeGuideAI', tick: 'true' },
        { title: 'enamelStudio', tick: 'true' },
        { title: 'dehazing', tick: 'true' },
        { title: 'colorChecker', tick: 'true' },
        {
          title: 'freeMobileAccess',
          tick: 'false',
        },
      ],
    },
    {
      title: 'Micro Layering',
      monthPrice: `€49/${t('month')}`,
      yearPrice: `€499/${t('year')}`,
      subPrice: `€44/${t('month')}`,
      features: [
        { title: 'myProjects', tick: 'true' },
        { title: 'shadeGuideAI', tick: 'true' },
        { title: 'enamelStudio', tick: 'true' },
        { title: 'dehazing', tick: 'true' },
        { title: 'colorChecker', tick: 'true' },
        {
          title: 'aestheticModel',
          tick: 'false',
        },
        {
          title: 'cameraRawPhoto',
          tick: 'false',
        },
        {
          title: 'frameworkAdvice',
          tick: 'false',
        },

        { title: 'skinEnamel', tick: 'false' },
        {
          title: 'internalEffects',
          tick: 'false',
        },
        {
          title: 'stainingStudio',
          tick: 'false',
        },
        {
          title: 'freeMobileAccess',
          tick: 'false',
        },
      ],
    },
    {
      title: 'Full Layering',
      monthPrice: `€79/${t('month')}`,
      yearPrice: `€799/${t('year')}`,
      subPrice: `€66/${t('month')}`,
      features: [
        { title: 'myProjects', tick: 'true' },
        { title: 'matisseLite', tick: 'true' },
        { title: 'shadeGuideAI', tick: 'true' },
        { title: 'enamelStudio', tick: 'true' },
        { title: 'dehazing', tick: 'true' },
        { title: 'colorChecker', tick: 'true' },
        {
          title: 'aestheticModel',
          tick: 'true',
        },
        {
          title: 'cameraRawPhoto',
          tick: 'true',
        },
        {
          title: 'frameworkAdvice',
          tick: 'true',
        },

        { title: 'skinEnamel', tick: 'true' },
        {
          title: 'internalEffects',
          tick: 'true',
        },
        {
          title: 'stainingStudio',
          tick: 'true',
        },
        {
          title: 'allInOne',
          tick: 'false',
        },
        {
          title: 'frameworkStaining',
          tick: 'false',
        },
        {
          title: 'opaquerRecipe',
          tick: 'false',
        },
        {
          title: 'dentinRecipe',
          tick: 'false',
        },
        {
          title: 'freeMobileAccess',
          tick: 'false',
        },
      ],
    },
    {
      title: 'Premium',
      monthPrice: `€95/${t('month')}`,
      yearPrice: `€935/${t('year')}`,
      subPrice: `€77/${t('month')}`,
      features: [
        { title: 'myProjects', tick: 'true' },
        { title: 'matisseLite', tick: 'true' },
        { title: 'shadeGuideAI', tick: 'true' },
        {
          title: 'enamelStudio',
          tick: 'true',
        },
        {
          title: 'dehazing',
          tick: 'true',
        },
        {
          title: 'aestheticModel',
          tick: 'true',
        },
        {
          title: 'colorChecker',
          tick: 'true',
        },
        {
          title: 'cameraRawPhoto',
          tick: 'true',
        },
        {
          title: 'frameworkAdvice',
          tick: 'true',
        },

        { title: 'skinEnamel', tick: 'true' },
        {
          title: 'internalEffects',
          tick: 'true',
        },
        {
          title: 'stainingStudio',
          tick: 'true',
        },
        {
          title: 'allInOne',
          tick: 'true',
        },
        {
          title: 'frameworkStaining',
          tick: 'true',
        },
        {
          title: 'opaquerRecipe',
          tick: 'true',
        },
        {
          title: 'dentinRecipe',
          tick: 'true',
        },
        {
          title: 'gingiva',
          tick: 'false',
        },
        {
          title: 'freeMobileAccess',
          tick: 'false',
        },
      ],
    },
  ]

  return (
    <Box
      sx={{
        width: '100%',
        margin: 'auto',
        marginTop: 8,
        marginBottom: '5rem',
        maxWidth: '500px',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <h1
          style={{
            letterSpacing: '0.24px',
            fontSize: '36px',
            fontFamily: 'roboto',
            textAlign: 'center',
            lineHeight: '3.5rem',
            marginBottom: '2.5rem',
            fontWeight: 600,
            color: '#B2DF8C',
          }}
        >
          {t('compareFeatures')}
        </h1>
      </div>
      <div
        style={{
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        {plans?.map((plan, index) => (
          <Accordion
            sx={{
              '&.Mui-expanded': {
                margin: 0,
              },
              bgcolor: 'black',
            }}
            key={index}
          >
            <AccordionSummary
              expandIcon={<MdExpandMore size={25} color="white" />}
              sx={{ bgcolor: '#2E2E2E', color: 'white' }}
            >
              <Typography
                sx={{
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <span
                  className={`compare-plan-col-title-${index + 1}`}
                  style={{
                    textAlign: 'left',
                    fontWeight: 700,
                    fontSize: '18px',
                    letterSpacing: '-0.015rem',
                  }}
                >
                  {plan.title}
                </span>
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ bgcolor: '#1E1E1E', color: 'white' }}>
              <>
                {plan.monthPrice && (
                  <Typography sx={{ fontWeight: 'bold' }} component="div">
                    <Box>
                      <Box display="flex" alignItems="center" gap="8px">
                        <span
                          style={{
                            fontSize: '12px',
                            color: '#c291b7',
                            lineHeight: '2rem',
                            fontWeight: 600,
                          }}
                        >
                          {`${plan?.yearPrice}`}
                        </span>
                        <span
                          style={{
                            color: 'white',
                            fontSize: '0.875rem',
                            fontWeight: '400',
                            lineHeight: '1.25rem',
                          }}
                        >
                          ({plan?.subPrice})
                        </span>
                      </Box>
                    </Box>
                  </Typography>
                )}

                <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                  <List>
                    {plan.features.map((feature, i) => (
                      <ListItem
                        key={i}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '4px 0',
                        }}
                      >
                        {feature.tick === 'true' ? (
                          <img
                            src={greenCheck}
                            alt="check"
                            style={{ width: 16 }}
                          />
                        ) : (
                          <img
                            src={bluetick}
                            alt="cross"
                            style={{ width: 16 }}
                          />
                        )}
                        <span
                          style={{
                            fontSize: '12px',
                            fontWeight: 400,
                            display: 'flex',
                          }}
                        >
                          {t(feature?.title)}{' '}
                          {[
                            'enamelStudio',
                            'dehazing',
                            'colorChecker',
                          ].includes(feature?.title) && t('digitalTryIn')}
                          {feature?.title === 'frameworkStaining' &&
                            t('washBake')}
                        </span>

                        <PlanDialog title={feature?.title} />
                      </ListItem>
                    ))}
                  </List>
                </ul>
                {buttonText && (
                  <Button
                    className="start-free-trial"
                    sx={{
                      '&:hover': {
                        backgroundColor: '#00abf0',
                      },
                      color: 'white',
                      background: '#FF47A0',
                      fontWeight: 500,
                      width: 'fit-content',
                    }}
                  >
                    {buttonText}
                  </Button>
                )}
              </>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </Box>
  )
}
